import { render, staticRenderFns } from "./CommunityMembersModal.vue?vue&type=template&id=c99a3750&scoped=true&"
import script from "./CommunityMembersModal.vue?vue&type=script&lang=ts&"
export * from "./CommunityMembersModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityMembersModal.vue?vue&type=style&index=0&id=c99a3750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99a3750",
  null
  
)

export default component.exports